import { Directive, ElementRef, HostListener, Input, AfterViewInit } from '@angular/core';

/**
 * Applies to any <textarea appAutoResize>.
 * The textarea grows automatically as the user types, up to a configurable
 * number of rows (default 10), then switches to scroll.
 * Respects the element's existing `rows` attribute as the minimum height.
 */
@Directive({
  selector: 'textarea[appAutoResize]'
})
export class AutoResizeTextareaDirective implements AfterViewInit {

  /** Maximum number of visible rows before the textarea scrolls instead of growing. */
  @Input() appAutoResizeMax = 10;

  constructor(private el: ElementRef<HTMLTextAreaElement>) {}

  ngAfterViewInit(): void {
    const ta = this.el.nativeElement;
    ta.style.overflowY = 'hidden';
    ta.style.resize = 'none';
    // Defer so reactive-form values are set before we measure
    setTimeout(() => this.doResize(), 0);
  }

  @HostListener('input')
  onInput(): void {
    this.doResize();
  }

  private doResize(): void {
    const ta = this.el.nativeElement;
    const style = getComputedStyle(ta);
    const lineHeight = parseFloat(style.lineHeight) || 20;
    const maxHeight = lineHeight * this.appAutoResizeMax;

    ta.style.height = 'auto';
    ta.style.height = Math.min(ta.scrollHeight, maxHeight) + 'px';
    ta.style.overflowY = ta.scrollHeight > maxHeight ? 'auto' : 'hidden';
  }
}
